// We officially support Chrome and Firefox. Any Chromium/Blink browser (Chrome,
// Edge, Brave, Opera, …) renders like Chrome, so it is treated as supported too.
// Safari/WebKit and unknown engines are unsupported.
export const isSupportedBrowser = (userAgent: string = navigator.userAgent): boolean => {
  const isFirefox = /Firefox\/|FxiOS/i.test(userAgent);
  // "Chrome/" appears in Chrome, Edge (also "Edg/"), Opera ("OPR/"), Brave, etc.
  // Safari's user agent has "Safari/" and "Version/" but none of these tokens.
  const isChromium = /Chrome\/|Chromium\/|CriOS/i.test(userAgent);

  return isFirefox || isChromium;
};
